export default String.raw`.contact-container__details{width:100%}.contact-container__form{width:100%}`